import { useSelector } from "react-redux"
import Icon from "../../ui/icons/Icon";
import { useRef, useState } from "react";
import iconsList from "../../ui/icons/iconsList";
import useClickOutside from "../../../hooks/useClickOutside";
import SimplePopup from "../../ui/popup/simplePopup/SimplePopup";
import classes from './Support.module.css';

const Support = () => {
    const { texts } = useSelector(state => state.translate);
    const supportRef = useRef(null);
    const [openSupportPopup, setOpenSupportPopup] = useState(false);
    const supportNumber = texts?.numberForSupport;
    const dialNumber = supportNumber?.replace(/[^\d*#+]/g, '');
    const digits = dialNumber?.split('');

    useClickOutside(supportRef, () => setOpenSupportPopup(false));

    return (
        <div className={classes.supportPopup} ref={supportRef}>
            <Icon
                name={iconsList.support}
                className={classes.UserIcon}
                size="26px"
                color={"#979797"}
                onClick={() => setOpenSupportPopup(prev => !prev)}
            />

            {openSupportPopup && (
                <SimplePopup anchored close={() => setOpenSupportPopup(false)} dropClassContainer={classes.AnchoredContainer}>
                    <div className={classes.AnchoredContent}>
                        <Icon className={classes.CloseAnchored} size="24px" name={iconsList.closeCircle} onClick={() => setOpenSupportPopup(false)} />
                        <div className={classes.box}>
                            <p className={classes.box__title}>
                                {texts?.ForQuestionsAboutTechnicalIssuesMalfunctions}
                            </p>
                            <a href={`tel:${dialNumber}`} className={classes.box__digits} aria-label={supportNumber}>
                                {digits?.map((digit, index) => (
                                    <span key={index} className={classes.box__digit}>
                                        {digit}
                                    </span>
                                ))}
                            </a>
                        </div>
                    </div>
                </SimplePopup>
            )}
        </div>
    );
}
export default Support